import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import axios from "axios";

const isTokenValid = () => {
  const token = localStorage.getItem("token");
  const createdAt = localStorage.getItem("token_created_at");
  if (!token || !createdAt) return false;

  const tokenDate = new Date(createdAt);
  const now = new Date();
  const diffDays = (now - tokenDate) / (1000 * 3600 * 24);

  return diffDays <= 10;
};

const PrivateRoute = ({ component: Component, ...rest }) => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    if (!isTokenValid()) {
      setHasAccess(false);
      setLoading(false);
      return;
    }

    // Check subscription access from your API
    axios
      .get(`${API_BASE_URL}/user/content-access`)
      .then((res) => {
        const active = res.data.some((order) => order.remaining_days > 0);
        setHasAccess(active);
        setLoading(false);
      })
      .catch(() => {
        setHasAccess(false);
        setLoading(false);
      });
  }, [API_BASE_URL]);

  if (loading) return <p>Loading...</p>;

  return (
    <Route
      {...rest}
      render={(props) =>
        hasAccess ? (
          <Component {...props} />
        ) : (
          <>
            {localStorage.removeItem("token")}
            {localStorage.removeItem("user")}
            {localStorage.removeItem("token_created_at")}
            <Redirect to="/login" />
          </>
        )
      }
    />
  );
};

export default PrivateRoute;
